import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import * as React from "react"
import { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Input } from "antd"
import { setFilterValue } from "../../filters/actions"
import type { FiltersIdentifier, FilterValue } from "../../filters/types"
import { getFilters, isStateLoading } from "../../filters/selectors"

type Props = {
    style?: Record<string, any>
    identifier: FiltersIdentifier
    dataLoading: boolean
    placeholder?: Maybe<string>
    value: Maybe<string>
    initialValue: Maybe<string>
    setFilter: (identifier: FiltersIdentifier, type: string, filterValue: FilterValue) => void
}
const defaultStyles = {
    width: "12rem",
}

const SearchFilterComponent: React.FC<Props> = props => {
    const [searchValue, setSearchValue] = useState(props.initialValue ?? "")

    useEffect(() => {
        setSearchValue(props.initialValue ?? "")
    }, [props.initialValue])

    return (
        <Input.Search
            style={{ ...defaultStyles, ...props.style }}
            className="searchFilterComponent"
            disabled={props.dataLoading}
            // @ts-expect-error
            placeholder={props.placeholder}
            value={searchValue}
            onSearch={value => {
                props.setFilter(props.identifier, "search", {
                    value: (value ?? "").trim(),
                })
            }}
            allowClear={true}
            onChange={e => setSearchValue(e.target.value)}
            enterButton={true}
        />
    )
}

const mapStateToProps = (state, props) => ({
    dataLoading: isStateLoading(state, props.identifier),
    initialValue: getFilters(state, props.identifier)?.search?.value,
})

const mapDispatchToProps = {
    setFilter: setFilterValue,
}
export default connect<any, any, any>(mapStateToProps, mapDispatchToProps)(SearchFilterComponent)
